import { useMutation } from 'react-query';
import { toastr } from 'react-redux-toastr';
import AffordaPortalFormsService from '../../services/affordaPortalFormsService';
import useSelectedProperty from '../../hooks/useSelectedProperty';
import { generateStandardFilename } from '@fortress-technology-solutions/fortress-component-library/utils';
import { defineMessages } from 'react-intl';
import useIntl from '../../hooks/useIntl';
import commonMessages from '../../containers/App/messages';

const messages = defineMessages({
  downloadSuccess: {
    id: 'application.download.success',
    defaultMessage: 'Application details downloaded successfully',
  },
  downloadError: {
    id: 'application.download.error',
    defaultMessage: 'Failed to download application details',
  },
});

const useDownloadAffordaPortalApplicationPDF = ({ options } = {}) => {
  const intl = useIntl();
  const { organizationId, id: propertyId } = useSelectedProperty();

  return useMutation(
    async ({ portalUserId, name }: { portalUserId: string, name: string }) => {
      const filename = generateStandardFilename({
        type: 'application-details',
        descriptor: name,
        extension: 'pdf',
      });

      return new AffordaPortalFormsService().downloadApplicationDetailsPDF({
        organizationId,
        propertyId,
        portalUserId,
        filename,
      });
    },
    {
      ...options,
      onSuccess: () => {
        toastr.success(
          intl.formatMessage(commonMessages.success),
          intl.formatMessage(messages.downloadSuccess),
        );
      },
      onError: (e) => {
        toastr.error(
          intl.formatMessage(commonMessages.errorDownloading),
          intl.formatMessage(messages.downloadError),
        );
      },
    },
  );
};

export default useDownloadAffordaPortalApplicationPDF;
